import { timeAgo } from "../format";
import { useTick } from "../hooks";

/** Its own component so the once-a-second re-render stays in the timestamps
    instead of walking the whole feed. */
export function TimeAgo({ ts }: { ts: number }) {
  useTick();
  return <span>{timeAgo(ts)}</span>;
}
